<template>
  <Header />
  <router-view />
  <Footer />
  <teleport to="head">
    <component :is="'script'" type="application/ld+json">
      {
        "@context": "https://schema.org",
        "@type": "MedicalBusiness",
        "name": "Logopädische Praxis Troisdorf-Spich",
        "description": "Logopädie in Troisdorf-Spich für Kinder und Erwachsene. Behandlung von Sprachstörungen, Stimmtherapie, Schlucktherapie und mehr.",
        "address": {
        "@type": "PostalAddress",
        "streetAddress": "Hauptstraße 226",
        "addressLocality": "Troisdorf-Spich",
        "postalCode": "53842",
        "addressCountry": "DE"
        },
        "telephone": "+492241 8468777"
      }
    </component>
  </teleport>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import { computed, reactive } from "vue";
import { useHead } from "@vueuse/head";

export default {
  setup() {
    const siteData = reactive({
      title: 'Lautstark Logopädie',
      description: 'My beautiful website'
    })
    useHead({
      title: computed(() => siteData.title),
      meta: [
        {
          name: 'description',
          content: computed(() => siteData.description),
        }, {
          name: 'keywords',
          content: 'Logopädie, Sprachtherapie, Stimmtherapie, Sprachtherapie Troisdorf, Logopädie Spich, ' +
              'Sprachtherapie für Kinder, Schlucktherapie, Stimmtherapie Erwachsene'
        }, {
          name: 'robots',
          content: 'index, follow'
        }
      ]
    })
  },
  components: {
    Header,
    Footer,
  },
};
</script>
